/*
 * Module for recent searches control
*/
rs.module("controls/universalsearch",

    /* dependencies */
    ["common/perfect-scrollbar", "ui/framework/client-templates"],

    function (perfectScrollbar, clientTemplates) {

        var scrollbars = [];

        // Initialize the universal search control
        function initialize(jsSelectors, cssClasses, backendUrl, loadingTemplateKey) {

            var control = $.js(jsSelectors.universalSearch);

            var searchButton = control.js(jsSelectors.searchButton);
            var queryInput = control.js(jsSelectors.searchQuery);
            var resultsWindow = control.js(jsSelectors.resultsWindow);
            var spinner = control.js(jsSelectors.loadingSpinner);
            var searchIcon = control.js(jsSelectors.searchIcon);

            var lastQuery = "";
            var searchCounter = 0;

            searchButton.on("click", _onSearchClick);
            queryInput.keyup(_.debounce(_onQueryChange, 400));

            // initiate a search
            function _onSearchClick() {
                _initiateSearch();
            }

            function _onQueryChange() {
                _initiateSearch();
            }

            function _initiateSearch() {
                var query = queryInput.val().trim();
                if (query !== lastQuery && query.length > 0){
                    lastQuery = query;

                    searchIcon.hide();
                    // set to inline-block so the animations work  
                    spinner.css('display', 'inline-block');

                    _showResultsWindow();
                    resultsWindow.html(clientTemplates.render(loadingTemplateKey));

                    // capture the search instance
                    searchCounter++;
                    var queryInstance = searchCounter;
                    $.get(backendUrl, { query: query }).done(function (results) {

                        // if these are the results for the most recent search, show them
                        if (queryInstance === searchCounter) {
                            searchIcon.show();
                            spinner.css('display', 'none');

                            resultsWindow.html(results);
                        }
                    })
                }
            }

            // display the results window
            function _showResultsWindow() {
                if (!resultsWindow.is(":visible")) {

                    resultsWindow.toggleClass(cssClasses.visible, true);

                    $(document).on("mouseup", _clickDocument);
                }
            }

            // Handler for clicking the document, outside of the visible results window
            function _clickDocument(e) {

                // clear the last query so results can be re-opened
                lastQuery = '';

                // close and detach handler
                if (!resultsWindow.is(e.target) && resultsWindow.has(e.target).length === 0) {
                    resultsWindow.toggleClass(cssClasses.visible, false);
                    $(document).off("mouseup", _clickDocument);
                }
            }
        }

        // search has completed, setup scrollbars
        function searchCompleted(jsSelectors, cssClasses) {
            for (var scrollbar of scrollbars) {
                scrollbar.destroy();
            }
            scrollbars = [];
            
            // Needs to be in setTimeout so the perfect scrollbar will show immediately
            setTimeout(function () {

                // setup perfect scrollbars
                var scrollContents = $.js(jsSelectors.scrollContent, { multiple: true, required: false });
                for (var scrollContent of scrollContents) {
                    scrollbars.push(perfectScrollbar.createInstance(scrollContent,
                        {
                            suppressScrollX: true,
                        }));
                }

                // Expand/collapse the sub results section
                scrollContents.js(jsSelectors.subResultsLink, { multiple: true, required: false }).click(function () {

                    // get the sub results section
                    var subResultsSection = $(this).closest(`[data-js=${jsSelectors.searchResult}]`).js(jsSelectors.subResultsSection);

                    var resultsExpanded = subResultsSection.is(":visible");

                    // Here we need explicit _inactive and _active classes (as opposed to just a single class we add/remove)
                    // This is becuase when results are to be expanded on load, there is a separate style that is controlling whether this should look active.
                    // In order to override that style when the results are collapsed, we need a separate class (_inactive) to do that
                    $(this).toggleClass(cssClasses.active, !resultsExpanded);
                    $(this).toggleClass(cssClasses.inactive, resultsExpanded);

                    subResultsSection.slideToggle(200);

                    // Since the sub results link is inside the main search result, we need to return false to stop propagation so it doesn't redirect 
                    return false;
                });

            }, 0);
        }

        var exports = {
            initialize: initialize,
            searchCompleted: searchCompleted
        }

        return exports;
    }
);